import React, { useEffect } from "react";
import { mergeStyleSets } from "@fluentui/react";
import { DocumentPartTreeSelection } from "./DocumentPartTree";
import { DocumentOutline } from "../document/DocumentOutline";
import { FlatPathTreeItem } from "../generic/FlatPathTreeExplorer";
import { fetchDocumentPartDetails } from "../../api/document/DocumentsPart";

export interface DocumentSourcesProps {
  onItemSingleClick: (item: DocumentPartTreeSelection) => void;
  idPartRoot: string;
}

export const DocumentSources: React.FunctionComponent<DocumentSourcesProps> = (props) => {
  const [documentPart, setDocumentPart] = React.useState<FlatPathTreeItem>(null);
  useEffect(() => {
    fetchDocumentPartDetails(props.idPartRoot).then((obj) =>
      setDocumentPart({ text: obj.name, key: obj.id, document: obj, readPermission: true })
    );
  }, [props.idPartRoot]);

  const classNames = mergeStyleSets({
    pageContainer: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0,
      height: "100%",
    },

    contentWrap: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0,
      overflow: "hidden",
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: 0,
    },
  });

  return (
    <div className="ms-Grid" dir="ltr" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="ms-Grid-row" style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        <div
          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
          style={{ zIndex: 1, display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}
        >
          {documentPart && (
            <div className={classNames.pageContainer}>
              <div className={classNames.contentWrap}>
                <div className={classNames.content}>
                  <DocumentOutline
                    onItemClick={props.onItemSingleClick}
                    isSourcesRibbon={true}
                    selectedTreeItem={documentPart}
                    idPartRoot={props.idPartRoot}
                    ignoreFetchPath={true}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
